export const defaultAuthoringSystem: string = 'communicare';
export const selfAuthoringSystemForeignKey: string = 'self';
export const emptyGuid: string = '00000000-0000-0000-0000-000000000000';
